import React from "react";
import BackButton from "../../../main/BackButton";
import Video from "../../../main/Video";

export default function Music() {
  return (
    <>
      <BackButton />
      <Video url={"https://yuriy-dmytrash19.wistia.com/medias/ptmiaqqryz"} maxHeight="80%" />
    </>
  );
}
